// @ts-check

/** @type {Record<string, {SIGNATURE: string, MIME_TYPE: string}>} */
export const FILE_EXTENSIONS = {
  jpg: {
    SIGNATURE: 'FFD8FFE0',
    MIME_TYPE: 'image/jpeg',
  },
  jpeg: {
    SIGNATURE: 'FFD8FFE0',
    MIME_TYPE: 'image/jpeg',
  },
  pdf: {
    SIGNATURE: '255044462D',
    MIME_TYPE: 'application/pdf',
  },
  png: {
    SIGNATURE: '89504E470D0A1A0A',
    MIME_TYPE: 'image/png',
  },
};

/**
 * Gets the format of the file based on its Base64-encoded content.
 *
 * It must not have 'data:' prefix.
 *
 * @param {string} base64Content The Base64-encoded content of the file.
 * @returns {string | undefined} The format of the file, or `undefined` if the format is not recognized.
 */
export function getFileExtensionFromBase64Content(base64Content) {
  const binaryContent = atob(base64Content);
  const fileSignatureLength = 16;
  let fileSignature = '';

  // Convert the first 16 bytes of binary data to hexadecimal string
  for (let i = 0; i < fileSignatureLength; i += 1) {
    const hex = binaryContent.charCodeAt(i).toString(16).padStart(2, '0');
    fileSignature += hex;
  }

  for (const [format, data] of Object.entries(FILE_EXTENSIONS)) {
    if (fileSignature.startsWith(data.SIGNATURE.toLowerCase())) {
      return format;
    }
  }

  return undefined;
}
